function sleep (second = 1) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, second * 1000);
    });
}
function getUrlParamsList () {
    var query = location.search.substring(1);
    query = query.split('&');
    var params = {};
    query && query.map(item => {
        const q = item.split('=');
        if (q.length === 2) params[q[0]] = q[1];
    });
    return params;
}
function compareVersions (version1, version2) {
    // 将版本号按点号分割成数组
    const v1 = version1.split('.').map(num => parseInt(num, 10));
    const v2 = version2.split('.').map(num => parseInt(num, 10));

    // 获取较长的版本号数组长度
    const length = Math.max(v1.length, v2.length);

    // 对比各个版本号部分
    for (let i = 0; i < length; i++) {
        const n1 = v1[i] || 0; // 如果没有该部分，默认是 0
        const n2 = v2[i] || 0;

        if (n1 > n2) return 1; // version1 > version2
        if (n1 < n2) return -1; // version1 < version2
    }
    return 0; // 版本号相等
}
function getOS () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log('userAgent', userAgent);
    // 判断操作系统
    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
    }
    if (/android/i.test(userAgent)) {
        return 'Android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
    }
    if (/Harmony/i.test(userAgent)) { // 检查 HarmonyOS
        return 'HarmonyOS';
    }
    if (/Win/.test(userAgent)) {
        return 'Windows';
    }
    if (/Mac/.test(userAgent)) {
        return 'macOS';
    }
    if (/Linux/.test(userAgent)) {
        return 'Linux';
    }
    if (/X11/.test(userAgent)) {
        return 'Unix';
    }
    return 'Unknown OS';
}

export function getUrlParams (name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = (window.location.search || window.location.hash).substr(1).match(reg);
    let strValue = '';
    if (r !== null) strValue = unescape(r[2]);
    return strValue;
}

function setWxUserInfo () {
    const token = getUrlParams('token');
    if (token) {
        sessionStorage.setItem('wxToken', token);
    }
}

function base64ToFile (base64Data, filename, mimeType) {
    // 1. 去除 Base64 头部（如果有）
    const base64WithoutHeader = base64Data.split(',')[1] || base64Data;
    
    // 2. 转换为二进制字符串
    const binaryString = atob(base64WithoutHeader);
    
    // 3. 转为 Uint8Array
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    
    // 4. 创建 Blob 并转为 File
    const blob = new Blob([bytes], { type: mimeType });
    return new File([blob], filename, { type: mimeType });
}

export {
    sleep,
    getUrlParamsList,
    getOS,
    compareVersions,
    setWxUserInfo,
    base64ToFile
};
